import { dataHooks } from '../../../libs/dataHooks';

export const megaMenuDataHooks = dataHooks<{
  toggle: {};
  megaMenuDropdown: {};
  simpleMenuDropdown: {};
}>('mega-menu');
